'use client'

import { Moon, Sun } from 'lucide-react'
import { useTheme } from 'next-themes'
import { useAuth } from '@/lib/stores/auth-store'
import { useEffect, useState } from 'react'

export function ThemeToggle() {
  const { setTheme, theme } = useTheme()
  const { user } = useAuth()
  const [mounted, setMounted] = useState(false)

  // Prevent hydration mismatch by only rendering after mount
  useEffect(() => {
    setMounted(true)
  }, [])

  const handleThemeChange = async (newTheme: string) => {
    setTheme(newTheme)
    
    // Save to Firebase if user is authenticated - use same structure as EOD reminders
    if (user?.id) {
      try {
        await fetch('/api/user-preferences', {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            userId: user.id,
            preferences: { theme: newTheme }
          })
        })
      } catch (error) {
        console.error('Failed to save theme preference:', error)
      }
    }
  }

  // Return a placeholder during SSR to prevent hydration mismatch
  if (!mounted) {
    return (
      <button type="button" className="of-nav-icon-btn" disabled aria-label="Toggle theme">
        <Sun className="h-4 w-4" />
      </button>
    )
  }

  return (
    <button
      type="button"
      className="of-nav-icon-btn"
      onClick={() => handleThemeChange(theme === 'light' ? 'dark' : 'light')}
      aria-label="Toggle theme"
      style={{ position: 'relative' }}
    >
      <Sun className="h-4 w-4 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-4 w-4 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
      <span className="sr-only">Toggle theme</span>
    </button>
  )
}